import { render, staticRenderFns } from "./UsuariosCadastroForm.vue?vue&type=template&id=482cafe0&scoped=true&"
import script from "./UsuariosCadastroForm.vue?vue&type=script&lang=js&"
export * from "./UsuariosCadastroForm.vue?vue&type=script&lang=js&"
import style0 from "./UsuariosCadastroForm.vue?vue&type=style&index=0&id=482cafe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482cafe0",
  null
  
)

export default component.exports